var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container-fluid mt-4"},[_c('hr',{staticClass:"border-primary"}),_c('div',{staticClass:"float-right m-2 small text-secondary"},[_vm._v(" "+_vm._s(_vm.version)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }